import { CircularProgress, Dialog } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { delete_event, get_event } from '../Redux/Action/EventAction';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const EventdeleteModal = ({ Opendel, setOpendel, deleteId }) => {
    const { t } = useTranslation('DeleteModal');
    const [loading, setLoading] = useState(false);
    const handleclose = () => {
        setOpendel(false);
    }
    const dispatch = useDispatch();

    const handledelete = (e) => {
        e.preventDefault();
        if (deleteId) {
            setLoading(true);
            dispatch(delete_event(deleteId)).then(() => {
                dispatch(get_event());
                setOpendel(false);
                toast.success(t("deleteMessage"))
            })
                .catch((error) => {
                    toast.error(t("delete_errormessage"));
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }
    return (
        <>
            <Dialog
                open={Opendel}
                onClose={handleclose}
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        width: "300px",
                    },
                }}

            >
                <div className="bg-white p-7  flex flex-col gap-5 rounded-[20px] ">

                    <div className="flex  items-start justify-end w-full ">

                        <span onClick={handleclose}><IoClose size={25} className='cursor-pointer' /></span>
                    </div>
                    <div className="  text-center flex flex-col justify-items-center gap-8">
                        <span className='bg-white rounded-full   text-center  mx-auto p-4 border-[2px] border-[#ED3939]'>
                            <IoClose fill='#ED3939' size={26} />
                        </span>

                        <div className="div">
                            <div className="text-[20px] font-[600]"> {t("title")} </div>
                            <p>{t("description")}</p>
                        </div>
                        <div className="flex gap-5  justify-center">
                            <button className='bg-[#EDF4FF] text-black rounded-lg  h-[40px]  w-full max-w-32 text-[14px] text-center' onClick={handleclose}>{t("cancelButton")}</button>
                            <button
                                type='submit'
                                className='bg-[#3686FF] text-white rounded-[10px] w-full h-[40px] text-[14px] hover:bg-[#2a6fd8] transition-colors disabled:opacity-50'
                                disabled={loading}
                                onClick={handledelete}
                            >
                                {loading ? <CircularProgress size={20} color="inherit" /> : t("deleteButton")}
                            </button>
                        </div>

                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default EventdeleteModal